<template>
  <component
    :is="showAsHeading ? TableHeadingCell : TableCell"
    :sortable="sortable"
    :top-header="topHeader"
    :index="index"
    :accessible-column-name="tableValue.value"
    :scope="scope"
  >
    <table-value-content :table-value="tableValue" />
  </component>
</template>

<script setup>
// eslint-disable-next-line import/no-extraneous-dependencies
import {computed} from "vue";
import TableHeadingCell from "./TableHeadingCell.vue";
import TableValueContent from "./TableValueContent.vue";
import TableCell from "./TableCell.vue";

const props = defineProps({
  /** @type {TableValue} */
  tableValue: Object,
  showAsHeading: Boolean,
  sortable: Boolean,
  topHeader: Boolean,
  index: Number,
});

const scope = computed(() => {
  if (props.showAsHeading) {
    if (props.topHeader) {
      return "col";
    } else {
      return "row";
    }
  }

  return undefined;
});
</script>